import { request } from "@/api/client";

export type CommandPaletteResult = {
  id: string;
  group: string;
  label: string;
  description?: string | null;
  route?: string | null;
  meta?: Record<string, any> | null;
};

export type CommandPaletteSearchResponse = {
  query: string;
  results: CommandPaletteResult[];
  counts: Record<string, number>;
};

export async function searchCommandPalette(query: string, limit = 24): Promise<CommandPaletteSearchResponse> {
  const search = new URLSearchParams();
  search.set("q", query);
  search.set("limit", String(limit));
  return request<CommandPaletteSearchResponse>(`/command-palette/search?${search.toString()}`);
}
